export const ENDPOINT = "https://api.almashhad.tk";